var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"pending-button",attrs:{"title":"Mark as Pending"}},[_c('i',{staticClass:"fa fa-clock pending-icon"})])
}
var staticRenderFns = []

export { render, staticRenderFns }